import { atom } from 'recoil';

const RouteState = atom({
    key: 'routeState',
    default: false
});

export default RouteState;